import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'
import { getFromS3 } from '../../lib/s3'
import type { Sticker } from './stickerSchemas'

const getStickerByIdSchema = z.object({
  id: z.string().min(1),
})

/**
 * Get a single sticker by id
 */
export const getStickerById = createServerFn({ method: 'GET' })
  .inputValidator(getStickerByIdSchema)
  .handler(async (ctx): Promise<Sticker> => {
    const { id } = ctx.data
    try {
      const sticker: Sticker = await getFromS3(`stickers/${id}.json`)
      return sticker
    } catch (error: any) {
      throw new Error(`Sticker not found: ${id}`)
    }
  })
